import React, { useState } from "react";
import "./PropertyDescriptor.scss";
import { containsInKey } from "../../../utils/helperFunctions";
import { DropdownIcon, DropUpIcon } from "../../../assets/icon/IconCollection";

interface Props {
  value: any;
  type: Type;
  isHeaderParameter?: boolean;
}

export enum Type {
  ApiRequest,
  ApiResponse,
  WebHookResponse,
  CommonErrors,
  CommonResponseParameters
}

const PropertyDescriptor: React.FC<Props> = ({ value, type, isHeaderParameter }) => {
  const [collapsed, setCollapsed] = useState(false);

  const properties: any =
    type === Type.ApiResponse || type === Type.CommonErrors
      ? value.data
      : type === Type.WebHookResponse
        ? value
        : value;

  const title = type === Type.ApiRequest
    ? (containsInKey(properties) ? "Request Parameters" : "Request Body")
    : type === Type.CommonErrors
      ? "ErrorDescriptionModel"
      : type === Type.CommonResponseParameters ? "Common Response Parameters"
        : "Response Body";

  const handleCollapseToggle = () => {
    setCollapsed(prevState => !prevState);
  }

  console.log(value)
  console.log(type);
  console.log(properties);

  return (
    <>
      <div>
        {properties && Object.keys(properties).length ? <>
          <div className="table-title">
            <h6 className="prop-desc-title">{isHeaderParameter ? 'Header Parameters' : title}</h6>
            <span className="collapse-icon" onClick={handleCollapseToggle}>
              {collapsed ? <DropUpIcon /> : <DropdownIcon />}
            </span>
          </div>
          <table className="w-100 custom-table">
            <thead className="table-header">
              <th style={{ width: "20%" }} className="text-start px-3 py-2">
                Property
              </th>
              {(type === Type.ApiRequest || type === Type.ApiResponse || Type.CommonErrors) && (
                <th style={{ width: "14%" }} className="text-start px-3 py-2">
                  Required
                </th>
              )}
              <th style={{ width: "15%" }} className="text-start px-3 py-2">
                Type
              </th>
              <th className="text-start px-3 py-2">Description</th>
            </thead>
            {!collapsed && <tbody>
              {Object.entries(properties).map(([key, val], index) => (
                <tr key={index}>
                  <td className="text-start px-3">
                    <span className="property-name">
                      {properties[key]["name"]}
                    </span>
                  </td>
                  {(type === Type.ApiRequest || type === Type.ApiResponse || Type.CommonErrors) && (
                    <td className="text-start px-3">
                      {properties[key]["required"] ? "true" : "false"}
                    </td>
                  )}
                  <td className="text-start px-3">
                    {properties[key]["fieldType"]}
                  </td>
                  <td className="text-start px-3">
                    {properties[key]["description"]}
                  </td>
                </tr>
              ))}
            </tbody>}
          </table> </> : null}
      </div>
    </>
  );
};

export default PropertyDescriptor;